<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             size="lg"
             no-close-on-esc
             no-close-on-backdrop
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">
      <form @submit.stop.prevent="handleOk">
        <b-row class="pb-1 pr-0">
              <b-col>
                <b-input autofocus type="text" v-on:keyup.enter="onScan()" v-model="form.chave"></b-input>
              </b-col>
              <b-col>
                <b-btn :disabled="loading" @click="onScan()" variant="secondary">Escanear código</b-btn>
              </b-col>
          <b-col md="2" class="p-0">
            <b-input hidden disabled type="text"></b-input>
          </b-col>
            </b-row>
        </form>
        <div class="loadingDataPosition">
            <div class="loadingData" v-if="loading"></div>
              <vuetable ref="vuetable"
                      :api-mode="false"
                      :data="docs"
                      :fields="fields"
                      :css="css"
                      :append-params="moreParams"
                      track-by="doc_id"
                      pagination-path=""
                      @vuetable:load-error="onError"
                      @vuetable:pagination-data="onPaginationData"
                      @vuetable:loaded="onLoaded"
                    >
                    <template slot="actions" slot-scope="props">
                        <!-- <i @click="removeCte(props.rowIndex)" class="fa fa-times" aria-hidden="true"></i> -->
                        <a :disabled="loading" @click="removeCte(props.rowData)" v-b-tooltip title="Remover nota"><i class="fa fa-times"></i></a>
                    </template>
              </vuetable>
          </div>
        <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                 <b-btn @click="handleOk($event)" :disabled="isDisabled" variant="secondary">
                   Finalizar
                 </b-btn>
                 <b-btn @click="handleFechar()"  variant="secondary">
                   Fechar
                 </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>

import AvisoErros from '../components/AvisoErros'
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import ExpedicaoCargaFormDetalhes from './ExpedicaoCargaFormDetalhes.vue'
Vue.component('expedicaocargaform-detalhes', ExpedicaoCargaFormDetalhes);

export default {
components: {
    AvisoErros,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    ExpedicaoCargaFormDetalhes,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      tp_fechar: false,
      permite_digitar: false,
      loading: false,
      isDisabled: true,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      errors_array: [],
      docs: [],
      cd_barra: '',
      doc: {
        num_cte: '',
        chave:'',
        usuario_bip:'',
        tp_doc: ''
      },
      docfis: [],
      form: new Form({
          carga_id: '',
          chave: '',
          docs: []
                    }),
     helpForm: new Form({search: '', doc_id: '', carga_id: ''}),
     fields: [
       {
         name: 'tp_doc',
         title: 'Tipo Doc',
       },
      {
        name: 'num_fiscal',
        title: 'N° Doc',
      },
       {
         name: 'chave',
         title: 'Chave',
       },
      {
        name: 'usuario_bip',
        title: 'Usuario BIP',
      },
      {
        name: '__slot:actions',
        title: 'Ações',
      },
     ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
methods: {
    handleOk(e)
    {
      e.preventDefault();
      if(this.modal_acao=="i")
      {
        this.onStore();
      }
      else
      {
        this.onUpdate(this.form.docfisttra_id);
      }
    },
    handleFechar() {
      this.$parent.onFilterReset();
      this.showModal = false;
      if (this.tp_fechar == true && this.docs.length > 0) {
        this.$snotify.success(
          "Carga " + this.docs[0].carga_id + " iniciada com sucesso.",
          "Sucesso"
        );
      }
    },
      onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit('setVuetableFilterButton', false);
    },
      onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onCreate (data, tipo, carga_id)
    {
      this.permite_digitar = this.checkPermissionBip();
      this.errors_array = '';
      this.errors_array = [];
      this.docfis = [];
      this.isDisabled = true;
      this.loading = false;
      this.modal_titulo = "Montagem de carga por CTE";
      this.modal_botao = "Finalizar";
      this.modal_acao = "i";
      this.form.reset();
      this.docs = [];
      if(tipo==2){
          this.tp_fechar = false;
          this.loading = true;
          this.isDisabled = true;
          if(carga_id != null) {
            this.form.carga_id = carga_id;
          } else {
            this.form.carga_id = data.doc_carga_doc[0].carga_doc.doc_fiscal.carga_bip_doc.carga_id;
          }

          this.form.post('/api/montagemporcte/getctecarga').then(response =>
          {
            new ReturnApi(response, this)
              response.items.forEach((item, i) => {
                  this.docs.push({
                    num_fiscal: item.num_fiscal,
                    chave: item.chave,
                    tp_doc: item.tp_doc,
                    usuario_bip: item.usuario_bip,
                    carga_id: item.carga_id,
                    doc_id: item.doc_id
                  })
              })
              this.form.docs = this.docs;
                
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this, true, null, null, false);
              this.errors_array = '';
              this.errors_array = [];
              for (var property in errors) {
                if (errors.hasOwnProperty(property)) {
                  if (typeof(errors[property]) === 'object') {
                    errors[property].forEach((obj) => {
                      this.errors_array.push({
                        erro: obj
                      });
                    });
                  }
                }
              }
          });
      } else {
        this.tp_fechar = true;
      }
      this.$refs.modal_form.show();
    },
    onScan()
    {
        this.errors_array = [];
        this.loading = true;
        this.isDisabled = true;
        this.form.post('/api/montagemporcte/checkcte').then(response =>
        {
            new ReturnApi(response, this)

          this.$snotify.success(
              "CTe N : " + response.data.num_fiscal + " bipada",
              "Sucesso"
          );
             this.docs.unshift({
                    num_fiscal: response.data.num_fiscal,
                    chave: response.data.chave ? response.data.chave : null,
                    tp_doc: response.data.tp_doc.descr,
                    usuario_bip: response.data.pessoa_juridica ? response.data.pessoa_juridica : response.data.pessoa_fisica,
                    carga_id: response.data.carga_id,
                    doc_id: response.data.doc_id
                // usuario_bip: response.carga_id,
              })
            this.form.carga_id = response.data.carga_id;
            this.form.docs = this.docs;
            this.form.chave = "";
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
          });
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.post('/api/montagemporcte/bip/store').then(response =>
        {
            new ReturnApi(response, this)
            this.$parent.onFilterReset();
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/montagemcarga/transportadora/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            this.$parent.onFilterReset();
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    removeCte(data){

      let helpForm = this.helpForm;
      var vm = this;
      var carga_id = data.carga_id;
      var doc_id = data.doc_id;
      const onConfirmUnitWrapper = () => {
        confirmDesassociarFn(vm, doc_id, carga_id);
      }

      let confirmDesassociarFn = function(vm, doc_id, carga_id) {
        vm.helpForm.doc_id = doc_id;
        vm.helpForm.carga_id = carga_id;

        vm.loading = true;
        vm.isDisabled = true;
        vm.helpForm.patch('/api/montagemporcte/bip/remover').then(response =>
        {
          vm.onCreate(null, 2, vm.helpForm.carga_id);
          new ReturnApi(response, vm, true, null, null, false)
        })
            .catch(errors =>
            {
              new ReturnApi(errors, vm, true, null, null, false);
              this.errors_array = '';
              this.errors_array = [];
              for (var property in errors) {
                if (errors.hasOwnProperty(property)) {
                  if (typeof(errors[property]) === 'object') {
                    errors[property].forEach((obj) => {
                      this.errors_array.push({
                        erro: obj
                      });
                    });
                  }
                }
              }
            });
      }

      let obj = {
        title: 'Atenção!',
        message: 'Todas as NFs do CTE selecionado serão removidos, deseja prosseguir ?',
        customConfirmBtnText: 'Sim',
        customCloseBtnText: 'Não',
        type: 'info',
        useConfirmBtn: true,
        onConfirm: onConfirmUnitWrapper
      }

      this.$Simplert.open(obj);

    },
    onRowClass (data, index) {
      return (data.qtde_bipada == data.qtde_total) ? 'table-success' : 'table-warning';
    },
    checkPermissionBip() {
        return this.getPermissionFw('expedicao.digitaretiqueta');//
    },
    onDetail (data, field, event) {
        this.$refs.vuetable.toggleDetailRow(data.doc_id);
    },
      onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito)
      {
          var cnpj_formatado
          var pad = "00000000"
          var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
          var pad = "0000"
          var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
          var pad = "00"
          var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;

          return cnpj_base+""+cnpj_filial+""+cnpj_digito;
      },

    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
